export default __webpack_public_path__ + "static/saas-crm-erp-solutions-6dae388c5655f0393c715d992934b5ca.pdf";